// Pure time helpers for the portal index page. Copy of
// src/components/legacy/index-time.ts — no React/Node deps.
// Asia/Shanghai has no DST, so a fixed +08:00 offset reproduces PHP
// date('H') and Carbon now() exactly.
export const SHANGHAI_OFFSET_MS = 8 * 60 * 60 * 1000;
export const START_2011_UTC_MS = Date.UTC(2011, 0, 1) - SHANGHAI_OFFSET_MS;
export const DAY_MS = 24 * 60 * 60 * 1000;
export type Season = "morning" | "noon" | "afternoon" | "night";
export function seasonForHour(hour: number): Season {
  if (hour >= 4 && hour < 10) return "morning";
  if (hour >= 10 && hour < 17) return "noon";
  if (hour >= 17 && hour < 20) return "afternoon";
  return "night";
}
export function indexTimeValues(nowMs: number): {
  season: Season;
  diffInYears: number;
  diffInDays: number;
} {
  const shanghai = new Date(nowMs + SHANGHAI_OFFSET_MS);
  return {
    season: seasonForHour(shanghai.getUTCHours()),
    diffInYears: shanghai.getUTCFullYear() - 2011,
    diffInDays: Math.floor((nowMs - START_2011_UTC_MS) / DAY_MS),
  };
}
